import { render, staticRenderFns } from "./freshmaRregistration.vue?vue&type=template&id=429a1779&scoped=true"
import script from "./freshmaRregistration.vue?vue&type=script&lang=js"
export * from "./freshmaRregistration.vue?vue&type=script&lang=js"
import style0 from "./freshmaRregistration.vue?vue&type=style&index=0&id=429a1779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a1779",
  null
  
)

export default component.exports